module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-07.92eec0b2.png";